export function getAuctionName(auctionTyper: string) {
  switch (auctionTyper) {
    case 'BUY_IT_NOW': {
      return 'Buy it now';
    }
    case 'BUY_IT_NOW_WITH_BIDS': {
      return 'Buy it now with bids';
    }
    case 'ENGLISH_AUCTION': {
      return 'English';
    }
    case 'DUTCH_AUCTION': {
      return 'Dutch';
    }
    case 'BLIND': {
      return 'Blind';
    }
    default: {
      return '';
    }
  }
}
